import { extend } from 'sk-ui/lib/utils/util.js'

import toolDetail from './metaData/toolDetail'
import toolForm from './metaData/toolForm'

import { offShelf, onShelf, getToolUrl } from '@/api/tool'
export default {
  ToolCreate({ commit }, params) {
    const props = {}
    const createForm = extend(true, {}, toolForm)
    this.dispatch('OpenFullDialog', {
      metaData: createForm,
      props
    })
  },

  ToolEdit({ commit }, params) {
    const props = {
      title: '编辑工具',
      params: {
        id: params.rowIds[0]
      },
      'view.content[$id=testCaseCode].$el': { disabled: true },
      'view.content[$id=testCaseType].$el': { disabled: true }
    }
    const editForm = extend(true, {}, toolForm)
    editForm.needFetchFillInfo = true
    this.dispatch('OpenFullDialog', { metaData: editForm, props, clone: false })
  },

  ToolDetail({ commit }, row) {
    const props = {
      params: {
        id: row.id
      }
    }
    this.dispatch('OpenDetailDialog', {
      metaData: toolDetail,
      props
    })
  },

  ToolDownload({ commit }, params) {
    if (params && params.row.provideMode === 'PROTECTION') {
      getToolUrl({ id: params.rowId })
        .then(response => {
          window.open(response.data.content, '_blank')
        })
        .catch(e => {
          throw e
        })
    } else {
      window.open(params.row.toolUrl, '_blank')
    }

    // let path = new URL(params.row.toolUrl).pathname
    // let fileName = path.split('/').pop()
    // let element = document.createElement('a')
    // element.href = params.row.toolUrl
    // element.target = '_blank'
    // element.download = fileName
    // element.style.display = 'none'
    // document.body.appendChild(element)
    // element.click()
    // document.body.removeChild(element)
  },

  ToolOnShelf({ commit }, params) {
    return onShelf({ id: params.rowId })
      .then(response => {
        params.viewController.fetch()
        this.dispatch('OpenNotification', { message: '上架成功', type: 'success' })
      })
      .catch(e => {
        throw e
      })
  },
  ToolOffShelf({ commit }, params) {
    return offShelf({ id: params.rowId })
      .then(response => {
        params.viewController.fetch()
        this.dispatch('OpenNotification', { message: '下架成功', type: 'success' })
      })
      .catch(e => {
        throw e
      })
  }
}
